var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    _vm._b(
      {
        attrs: { color: _vm.value ? "primary" : "" },
        on: {
          click: function($event) {
            return _vm.$emit("input", !_vm.value)
          }
        }
      },
      "v-btn",
      _vm.$attrs,
      false
    ),
    [
      _vm._v("\n  " + _vm._s(_vm.label) + "\n  "),
      _vm.value
        ? _c("v-icon", { attrs: { small: "" } }, [
            _vm._v("mdi-check-box-outline")
          ])
        : _c("v-icon", { attrs: { small: "" } }, [
            _vm._v("mdi-checkbox-blank-outline")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }